import type { IconSize, IconColor } from '../icon';

export enum TagType {
  CLICKABLE = 'clickable',
  DEFAULT = 'default',
  DISMISSABLE = 'dismissable',
}

export enum TagColor {
  DANGER = 'danger',
  DANGER_LIGHT = 'danger-light',
  DARK_GREEN = 'dark-green',
  LIGHT = 'light',
  MID = 'mid',
  MID_LIGHT = 'mid-light',
  PREFERRED_FREELANCER = 'preferred-freelancer',
  PREFERRED_FREELANCER_LIGHT = 'preferred-freelancer-light',
  PRIMARY = 'primary',
  PRIMARY_LIGHT = 'primary-light',
  SECONDARY = 'secondary',
  SECONDARY_DARK = 'secondary-dark',
  SECONDARY_XDARK = 'secondary-xdark',
  SUCCESS = 'success',
  SUCCESS_LIGHT = 'success-light',
  YELLOW_LIGHT = 'yellow-light',
  INHERIT = 'inherit',
}

export enum TagSize {
  LARGE = 'large',
  MID = 'mid',
  SMALL = 'small',
}

export interface IconConfig {
  name: string;
  size: IconSize;
  useIconFont?: boolean;
  label?: string;
  color?: IconColor;
}
